var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(" Default slot content ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }